import React from 'react';

const UpdatesSkeleton: React.FC = () => {
  return (
    <>
      {[1, 2, 3].map((item) => (
        <div 
          key={item}
          className="animate-pulse bg-gray-200 rounded-lg p-3 mb-2"
        >
          <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
          <div className="h-3 bg-gray-300 rounded w-full mb-2"></div>
          <div className="h-2 bg-gray-300 rounded w-1/3"></div>
        </div>
      ))}
    </>
  );
};

export default UpdatesSkeleton;
